import { useEffect } from "react";
import { useLocation } from "wouter";

export function ScrollToTop() {
  const [pathname] = useLocation();

  useEffect(() => {
    // Instantly scroll to top when the path changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Using instant for better SPA feel, can use "smooth" if preferred
    });
  }, [pathname]);

  return null;
}
